import React from 'react';
import RedTopNav from './RedTopNav';
import { FaFacebook } from "react-icons/fa";
import { SiInstagram } from "react-icons/si";
import { FaWhatsapp } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa6";

function RedesTopNavbar({ extraStyle, size, iconStyle, footer }) {
  // Define las URLs de las redes sociales
  const urls = {
    youtube: "https://www.youtube.com/@AgroH-u3v",
    whatsapp: "https://wa.me/543815585138",
    facebook: "https://www.facebook.com/profile.php?id=100081705529184",
    instagram: "https://www.instagram.com/agrohtucuman/",
  };

  return (
    <div className={`md:flex md:justify-evenly lg:justify-around pt-2 ${extraStyle}`}>
      <RedTopNav iconStyle={iconStyle} color={`${footer && ("text-YOUTU")}`} href={urls.youtube} item={<FaYoutube size={size} />} />
      <RedTopNav iconStyle={iconStyle} color={`${footer && ("text-WSPP")}`} href={urls.whatsapp} item={<FaWhatsapp size={size} />} />
      <RedTopNav iconStyle={iconStyle} color={`${footer && ("text-FACE")}`} href={urls.facebook} item={<FaFacebook size={size} />} />
      <RedTopNav iconStyle={iconStyle} color={`${footer && ("text-INSTA")}`} href={urls.instagram} item={<SiInstagram size={size} />} />
    </div>
  );
}

export default RedesTopNavbar;
